import React from 'react';
import { Routes, Route } from "react-router-dom";

import Loader from './Components/Loader';
import routes from './routes';

const App = () => {
    return (
        <div className="app-content">
            <Loader />
            <Routes>
                { routes.map((route, index) => (
                <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                />
                )) }
            </Routes>
        </div>
    );
}

export default App;